import { useState } from "react";
import axios from '../Axios/Default';
import { handleResponse } from './HelperService';

export const useUploadForm = () => {
  const [progress, setProgress] = useState(0);

  const uploadForm = (url, formData, onSuccess, onError) => {
    const response = axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: progressEvent => {
        let { loaded, total } = progressEvent;
        setProgress(Math.round((loaded / total) * 100));
      },
      //   onDownloadProgress: (progressEvent) => {
      //     setProgress(Math.round((100 * progressEvent.loaded) / progressEvent.total));
      //   },
    });



    return handleResponse(response, onSuccess, onError);
  };


  return { uploadForm, progress };

};